import cn from 'classnames';
import type React from 'react';
import { Close } from '@shared/assets';
import { IconButton } from '@shared/ui/buttons';
import * as st from './styles.module.scss';

interface Props {
  left?: JSX.Element;
  right?: JSX.Element;
  title?: string | JSX.Element;
  onClose: () => void;
  children?: React.ReactNode;
  middleClassName?: string;
  IconNode?: React.ReactNode;
}

export const MediumHeader: React.FC<Props> = ({
  left,
  right,
  title,
  onClose,
  middleClassName,
  IconNode = <Close />,
}) => {
  return (
    <div className={st.header}>
      <div className={st.header__left}>
        <IconButton variant="white" onClick={onClose}>
          {IconNode}
        </IconButton>
        {left}
      </div>
      <div className={cn(st.header__middle, middleClassName)}>
        <h3 className={st.header__title}>{title}</h3>
      </div>
      <div className={st.header__right}>
        <>{right}</>
      </div>
    </div>
  );
};
